import { render, staticRenderFns } from "./submission-details.vue?vue&type=template&id=04d292bf"
import script from "./submission-details.vue?vue&type=script&lang=js"
export * from "./submission-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports